export default __webpack_public_path__ + "static/media/icon_bandstyle_Edged.13d85154.png";